import React from 'react';
import { Route, Redirect } from 'react-router';

import { GuardedRoute } from 'app/dealer/shared/components/GuardedRoute/GuardedRoute';
import { authorities } from 'app/dealer/constants';
import { fetchAuthorities } from 'app/dealer/shared/modules/authorities/actions';

import { getNetwork } from './Network/actions';

const { MANAGE_MY_NETWORK, READ_MY_NETWORK } = authorities;
const requiredAuthorities = [MANAGE_MY_NETWORK, READ_MY_NETWORK];

const refreshNetworkAndAuthorities = ({ dispatch }) => async (
  nextState,
  replace,
  next,
) => {
  try {
    await dispatch(getNetwork());
    await dispatch(fetchAuthorities());
    return next();
  } catch (error) {
    return next();
  }
};

export const getAccountRoutes = store => {
  const { getState } = store;

  return (
    <Route name="account" onEnter={refreshNetworkAndAuthorities(store)}>
      <Redirect from="/dealer/account" to="/dealer/account/network" />
      <GuardedRoute
        getComponent={() =>
          import('./Account/Account/ConnectedAccount').then(
            c => c.ConnectedAccount,
          )
        }
        getState={getState}
        path="/dealer/account"
        redirectTo="/dealer/login"
        requiredAuthorities={requiredAuthorities}
      >
        <Route
          path="/dealer/account/network"
          getComponent={() =>
            import('./Network/Network/ConnectedNetwork').then(
              c => c.ConnectedNetwork,
            )
          }
        />
        <GuardedRoute
          getComponent={() =>
            import('./Billing/Billing/ConnectedBilling').then(
              c => c.ConnectedBilling,
            )
          }
          getState={store.getState}
          path="/dealer/account/billing"
          redirectTo="/dealer/login"
          requiredAuthorities={requiredAuthorities}
        />
        <Route
          getComponent={() =>
            import('./Branches/Branches/ConnectedBranches').then(
              c => c.ConnectedBranches,
            )
          }
          path="/dealer/account/branches"
        />
        <Route
          getComponent={() =>
            import('./Branch/NewBranch/ConnectedNewBranch').then(
              c => c.ConnectedNewBranch,
            )
          }
          path="/dealer/account/new-branch"
        />
        <Route
          getComponent={() =>
            import('./Branch/Branch/ConnectedBranch').then(
              c => c.ConnectedBranch,
            )
          }
          path="/dealer/account/branch(/:id)"
        />
        <Route
          getComponent={() =>
            import('./Terms/Terms/ConnectedTerms').then(c => c.ConnectedTerms)
          }
          path="/dealer/account/terms"
        />
        <Route
          getComponent={() =>
            import('./Settings/Settings/Settings').then(c => c.Settings)
          }
          path="/dealer/account/settings"
        />
        <Route
          getComponent={() =>
            import(
              './DealerProfileSettings/DealerProfileSettings/DealerProfileSettings'
            ).then(c => c.DealerProfileSettings)
          }
          path="/dealer/account/dealer-profile-settings"
        />
        <GuardedRoute
          getComponent={() =>
            import('./PaymentMethod/PaymentMethod/ConnectedPaymentMethod').then(
              c => c.ConnectedPaymentMethod,
            )
          }
          getState={store.getState}
          path="/dealer/account/payment-method"
          redirectTo="/dealer/login"
          requiredAuthorities={requiredAuthorities}
        />
      </GuardedRoute>
    </Route>
  );
};
